export const kpiState: {
  data: {
    [viewType: string]: {
      [kpiCode: string]: {
        loading: boolean
        error: string
        result: any
      }
    }
  }
} = {
  data: {},
}
